import { useTranslation } from '@sortlist-frontend/translation/ssr';
import Image from 'next/image';
import { Fragment } from 'react';

import { rankingConfig } from '../ranking.config';
import type { RankingAuthor } from '../types';

interface RankingAuthorCardProps {
  author: RankingAuthor;
}

export const RankingAuthorCard = (props: RankingAuthorCardProps) => {
  const { author } = props;
  const { t } = useTranslation(rankingConfig.i18nNamespaces);

  return (
    <div className="flex flex-col gap-4 rounded-2xl border border-secondary-200 bg-secondary-50 p-5 sm:flex-row md:p-6">
      <Image
        src={author.avatarUrl}
        alt={author.name}
        width={64}
        height={64}
        loading="lazy"
        unoptimized
        className="h-16 w-16 shrink-0 rounded-full"
      />
      <div className="text-sm leading-relaxed text-secondary-700">
        <p className="font-semibold text-secondary-950">
          {t('longtail:ranking.author.aboutTitle')}{' '}
          <a href={author.href} rel="author" className="font-semibold text-primary-600 underline underline-offset-2">
            {author.name}
          </a>
        </p>
        <p className="mt-2">{author.bio}</p>
        <p className="mt-2">
          {author.links.map((link, index) => (
            <Fragment key={link.href}>
              {index > 0 ? ' · ' : null}
              <a
                href={link.href}
                rel="me noopener"
                target="_blank"
                className="text-primary-600 underline underline-offset-2">
                {link.label}
              </a>
            </Fragment>
          ))}
        </p>
      </div>
    </div>
  );
};
